import { render, staticRenderFns } from "./quote-history-description.vue?vue&type=template&id=53559c6a&"
import script from "./quote-history-description.vue?vue&type=script&lang=ts&"
export * from "./quote-history-description.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports